// components/CustomJoyride/CustomJoyride.tsx
import React from "react";
import { CallBackProps, Step } from "react-joyride";
import dynamic from "next/dynamic";
import { colourScheme } from "utils/styling/colours"; // Adjust the import path as needed

interface CustomJoyrideProps {
  steps: Step[];
  run: boolean;
  stepIndex: number;
  disableScrolling?: boolean;
  callback?: (data: CallBackProps) => void;
}
const JoyrideNoSSR = dynamic(() => import("react-joyride").then(mod => mod.default), {
  ssr: false
});
const CustomJoyride: React.FC<CustomJoyrideProps> = ({
  steps,
  run,
  stepIndex,
  disableScrolling,
  callback
}) => {
  return <JoyrideNoSSR steps={steps} run={run} callback={callback} stepIndex={stepIndex} continuous={true} showProgress showSkipButton disableScrolling={disableScrolling} styles={{
    options: {
      arrowColor: colourScheme.primaryLight,
      backgroundColor: colourScheme.primaryLight,
      textColor: colourScheme.white,
      overlayColor: "rgba(0, 0, 0, 0.5)",
      spotlightShadow: "0 0 15px rgba(255, 255, 255, 0.5)",
      zIndex: 10000
    },
    buttonNext: {
      backgroundColor: colourScheme.primaryDark,
      color: colourScheme.white
    },
    buttonBack: {
      color: colourScheme.secondaryLight
    },
    buttonSkip: {
      color: colourScheme.error
    },
    tooltip: {
      borderRadius: "0.5rem",
      padding: "1.25rem"
    }
  }} data-sentry-element="JoyrideNoSSR" data-sentry-component="CustomJoyride" data-sentry-source-file="index.tsx" />;
};
export default CustomJoyride;